import { get } from '../utils/api';

class MasterRDProjectRentalTypesService {
  getAll() {
    return get('/master-rd-project-rental-types');
  }
}

export default MasterRDProjectRentalTypesService;
